import { useContext } from "react";
import { useQuery } from "react-query";

import { UserContext } from "../../../App";
import { get_shop_by_id, get_shops } from "../../Client";

export const useGetAllShopsQuery = (options: any = {}) => {
    return useQuery("shops", () => get_shops(), options);
};

export const useGetShopByIdQuery = (shopId: string) => {
    return useQuery(["shops", shopId], () => get_shop_by_id(shopId));
};

export const useGetShopsByShopIdFromUserProfile = (shopId: string) => {
    const { profile } = useContext(UserContext);
    if (!profile) return "";
    for (const group of profile?.shop_groups) {
        const shop = group?.shops?.find((s) => s?.id === shopId);
        if (shop) return shop.name;
    }
    return null;
};
